import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import { connect } from 'react-redux';
import BarberHoverMenuTimeTracking from '../components/BarberHoverMenuTimeTracking';
import { getBarberClockedTime } from '../selectors';
import showForTimeTrackingEnabled from '../hoc/showForTimeTrackingEnabled';
import { isBarberUser } from '../../../auth/selectors';

const BarberHoverMenuTimeTrackingContainer = compose(
  showForTimeTrackingEnabled,
  connect(
    (state, ownProps) => ({
      clockedTime: getBarberClockedTime(state, ownProps.barberId),
      isBarberUser: isBarberUser(state),
    }),
  ),
  branch(
    props => props.isBarberUser,
    renderNothing
  )
)(BarberHoverMenuTimeTracking);

export default BarberHoverMenuTimeTrackingContainer;
